export default __webpack_public_path__ + "html/simplechart.html";